/** Backend API (FastAPI). Trailing slash stripped. */

const PRODUCTION_HOSTS = ["asistentpersonal.ro", "szemelyiasszisztens.hu"]

/** DO component path when ingress still uses /mypersonalassistant-backend instead of /api. */
const DO_LEGACY_API_PREFIX = "/mypersonalassistant-backend"

function resolveBackendUrl() {
  const fromEnv = (process.env.REACT_APP_BACKEND_URL ?? "").trim()
  if (fromEnv) return fromEnv.replace(/\/$/, "")

  if (typeof window === "undefined") return "http://127.0.0.1:8000"

  const host = window.location.hostname.replace(/^www\./, "")
  if (PRODUCTION_HOSTS.some((h) => host === h || host.endsWith(`.${h}`))) {
    return `${window.location.origin}${DO_LEGACY_API_PREFIX}`
  }

  return window.location.origin
}

export const BACKEND_URL = resolveBackendUrl()
export const API_BASE = `${BACKEND_URL}/api`

/** Supabase project (public URL + anon key — safe in browser). */
export const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL || ""
export const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY || ""
